export default __webpack_public_path__ + "static/media/keyBoardIllustrator.2ea8b095.svg";